export const DELETE_CLASS_REASON_OPTIONS = [
  { value: 1, label: 'Health reasons of the instructor' },
  { value: 2, label: 'Unforeseen circumstances at the end of the instructor' },
  { value: 3, label: 'Emergency at the place of the instructor' },
  { value: 4, label: 'Network issues at the place of the instructor' },
  { value: 5, label: 'Medical emergency at the place of the instructor' },
  { value: 6, label: 'Unavailability of the Instructor' },
];
